import BaseSyncError from "scripts/exceptions/baseSyncError";

class UnprocessableEntitySyncError extends BaseSyncError {}

export default UnprocessableEntitySyncError;
